module.exports = __webpack_public_path__ + "img/GHS03.ce560ff6.gif";